import * as z from 'zod/mini';
import { getSession, setSession } from 'helpers/storage/storage';
const participationsSchema = z.record(z.string(), z.optional(z.string()));
// For participation in tests defined in abtestDefinitions.ts
const PARTICIPATIONS_KEY = 'abParticipations';
// For participation in landing page tests, which are passed through from the server
const LANDING_PAGE_PARTICIPATIONS_KEY = 'landingPageParticipations';
const CHECKOUT_NUDGE_PARTICIPATIONS_KEY = 'checkoutNudgeParticipations';
const ONE_TIME_CHECKOUT_PARTICIPATIONS_KEY = 'oneTimeCheckoutParticipations';
const STUDENT_LANDING_PAGE_PARTICIPATIONS_KEY = 'studentLandingPageParticipations';
function getSessionParticipations(key) {
    try {
        return getSession(key, participationsSchema) ?? undefined;
    }
    catch (error) {
        console.error(`Failed to fetch ${key} from session storage`, error);
        return undefined;
    }
}
function setSessionParticipations(participations, key) {
    setSession(key, participations);
}
function clearParticipationsFromSession() {
    setSession(PARTICIPATIONS_KEY, {});
    setSession(LANDING_PAGE_PARTICIPATIONS_KEY, {});
    setSession(ONE_TIME_CHECKOUT_PARTICIPATIONS_KEY, {});
    setSession(STUDENT_LANDING_PAGE_PARTICIPATIONS_KEY, {});
}
export { clearParticipationsFromSession, getSessionParticipations, setSessionParticipations, PARTICIPATIONS_KEY, LANDING_PAGE_PARTICIPATIONS_KEY, CHECKOUT_NUDGE_PARTICIPATIONS_KEY, ONE_TIME_CHECKOUT_PARTICIPATIONS_KEY, STUDENT_LANDING_PAGE_PARTICIPATIONS_KEY, };
